import { BackendFetch } from "@hantera/portal-app";
import parseJson from "../parse-json";

export default function (portalFetch: BackendFetch) {

  return {

    /**
     * Returns the customer's orders (up to 1000)
     * @param customerEmail
     */
    async getCustomerOrders(customerEmail: string) {
      const res = await portalFetch('/legacy-customers/getCustomerOrders', {
        method: 'POST',
        body: JSON.stringify({
          customerEmail,
        }),
      });

      if (res.ok) {
        return parseJson(await res.text());
      }
    },


  };

}